import { FormattedMessage, useIntl } from 'react-intl';
import { Button, ToggleButton, ToggleButtonGroup } from '@atoms/buttons';
import { Box, Flex } from '@atoms/layout';
import { useNavigate } from 'react-router-dom';
import { Tooltip, useTheme } from '@mui/material';
import { FaIcon } from '@atoms/icons';
import { useShiftTypePresetDrawerStore } from '@libs/store/shiftTypePresets';

type TableMenuProps = {
  loading?: boolean;
  localizationSubset: string;
};
export function ShiftTypePresetsTableMenu({ loading, localizationSubset }: TableMenuProps) {
  const theme = useTheme();
  const navigate = useNavigate();
  const intl = useIntl();
  const openDrawer = useShiftTypePresetDrawerStore((s) => s.openDrawer);
  const currentPath = location.pathname;
  const paths = {
    templates: '/schedule/templates/shifts-series-n-rotations',
    types: '/schedule/templates/shift-types',
  };
  const locationListMapping: Record<string, string> = {
    [paths.templates]: 'templates',
    [paths.types]: 'types',
  };
  const handleNewButtonClick = () => {
    openDrawer();
  };

  return (
    <>
      <Flex gap={2}>
        <ToggleButtonGroup value={locationListMapping[currentPath]}>
          <ToggleButton value="templates" size="large" onClick={() => navigate(paths.templates)}>
            <FormattedMessage id={`${localizationSubset}.menu.switch.templates.label`} />
          </ToggleButton>
          <ToggleButton value="types" size="large" onClick={() => navigate(paths.types)}>
            <FormattedMessage id={`${localizationSubset}.menu.switch.types.label`} />
          </ToggleButton>
        </ToggleButtonGroup>
        <Box flex={1} />
        <Tooltip title={intl.formatMessage({ id: `${localizationSubset}.menu.newTemplateButton.tooltip` })}>
          <Button variant="contained" onClick={handleNewButtonClick} sx={{ maxHeight: '40px', paddingX: 4 }}>
            <FaIcon name="plus" color={theme.palette.background.paper} />
            <Box sx={(theme) => ({ marginLeft: theme.spacing(2) })}>
              <FormattedMessage id={`${localizationSubset}.menu.newTemplateButton.label`} />
            </Box>
          </Button>
        </Tooltip>
      </Flex>
    </>
  );
}
